
var ad_base = function () {
  var self = this;
  self.init();
};

ad_base.prototype.init = function () {
  // Inicializamos el material bootstrap
  jQuery.material.init({validate: false});
};

jQuery( document ).ready(function() {
  window.ad_base = new ad_base();
});
